<template>
</template>

<script>
export default {
    data: function () {
        return {
            changePassword: false,
        }
    },
    mounted() {
    }
}
</script>